module.exports = __webpack_public_path__ + "img/bim.7ebb0107.png";